import CustomInput from 'src/components/general/Form'
import styled from 'styled-components'
import { useCallback } from 'react'

interface DefaultVolumeLimitEditProps {
  task: {
    id: string
    taskConfig: {
      defaultVolumeLimit: {
        id: string
        amount: string
        period: string
        token: {
          id: string
          decimals: number
          name: string
          symbol: string
        }
      }
    }
  }
  handleInputChange: (taskId: string, field: string, value: string) => void
}

const DefaultVolumeLimitEdit: React.FC<DefaultVolumeLimitEditProps> = ({ task, handleInputChange }) => {
  const memoizedHandleInputChange = useCallback(
    (field: string, value: string) => handleInputChange(task.id, field, value),
    [task.id, handleInputChange]
  )

  return (
    <div>
      <div className="flex-group">
        <FlexColumn>
          <Flex>
            <CustomInput
              type="text"
              name="amount"
              label="Amount"
              value={task?.taskConfig?.defaultVolumeLimit?.amount || ''}
              onChange={(e) => memoizedHandleInputChange('defaultVolumeLimit.amount', e.target.value)}
            />
          </Flex>
          <Flex>
            <CustomInput
              type="text"
              name="period"
              label="Period"
              value={task?.taskConfig?.defaultVolumeLimit?.period || ''}
              onChange={(e) => memoizedHandleInputChange('defaultVolumeLimit.period', e.target.value)}
            />
          </Flex>
          <TokenRow>
            <TokenLabel>
              <strong>Address:</strong> {task?.taskConfig?.defaultVolumeLimit?.token?.id || 'N/A'}
            </TokenLabel>
          </TokenRow>
          <TokenRow>
            <TokenLabel>
              <strong>Symbol:</strong> {task?.taskConfig?.defaultVolumeLimit?.token?.symbol || 'N/A'}
            </TokenLabel>
            <TokenLabel>
              <strong>Name:</strong> {task?.taskConfig?.defaultVolumeLimit?.token?.name || 'N/A'}
            </TokenLabel>
            <TokenLabel>
              <strong>Decimals:</strong> {task?.taskConfig?.defaultVolumeLimit?.token?.decimals || 'N/A'}
            </TokenLabel>
          </TokenRow>
        </FlexColumn>
      </div>
    </div>
  )
}

export default DefaultVolumeLimitEdit

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`

const Flex = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
`

const TokenLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #a0a0a0;
  strong { color: #ededed; font-weight: 500; }
`

const TokenRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 8px;
  padding: 10px 12px;
  background: #111;
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 6px;
` 